<template>
  <div id="post-modal">
    <!-- Post modal -->
    <transition name="fade">
      <div class="post-modal">
        <div class="post-modal-content">
          <div class="post-modal-header">
            <a @click="closePostModal" class="close"><i class="far fa-times"></i></a>
            <p class="lead">{{ fullPost.title }}</p>
          </div><!-- /.post-modal-header -->
          <div class="post-modal-body">

            <Post :fullPost="fullPost"></Post>

          </div><!-- /.post-modal-body -->
          <div class="post-modal-footer">
            <router-link :to="{ name: 'Post', params: { id: fullPost.id }}">View Post</router-link>
            <div class="float-right">
              <button @click="openEditPostModal(fullPost)" class="btn btn-primary"><i class="far fa-pencil"></i> Edit</button>
              <button @click="closePostModal" class="btn btn-default">Close</button>
            </div><!-- /.btn-group -->
          </div><!-- /.post-modal-footer -->
        </div><!-- /.post-modal-content -->
      </div><!-- post-modal -->
    </transition>
  </div><!-- /#post-modal -->
</template>

<script>
  import moment from 'moment'
  import Post from './Post.vue'

  export default {
    props: ['fullPost'],
    components: { Post },
    data() {
      return {
      }
    },
    created: function () {
      let self= this;
      let map = null;
      setTimeout(function () {
        map = new google.maps.Map(document.getElementById('map'), {
          center: {lat: self.fullPost.coordinates.latitude,lng: self.fullPost.coordinates.longitude},
          zoom: 18,
          scrollwheel: false
        });
        let marker = new google.maps.Marker({
          map: map,
          position: {lat: self.fullPost.coordinates.latitude,lng: self.fullPost.coordinates.longitude}
        });
        let address = self.fullPost.address
        let infowindow = new google.maps.InfoWindow({
          content: address.route + "<br>" + address.locality + " " + address.administrative_area_level_1 + ", " + address.postal_code
        });
        if (address.route) {
          infowindow.open(map, marker);
          marker.addListener('click', function() {
            infowindow.open(map, marker);
          });
        }
      }, 10);
    },
    methods: {
      formatFigure(value) {
        let val = (value/1).toFixed(0).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
      closePostModal() {
        this.$emit('closePostModal', false)
      },
      openEditPostModal(fullPost) {
        this.$emit('openEditPostModal', fullPost)
        this.$emit('closePostModal', false)
      }
    },
    filters: {
      formatDate(val) {
        if (!val) { return '-' }
        let date = val.toDate()
        return moment(date).fromNow()
      },
      trimLength(val) {
        if (val.length < 200) { return val }
        return `${val.substring(0, 200)}...`
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PostModal.vue